import {
  IconArrowBarToRight,
  IconArrowsMove,
  IconEraser,
  IconFence,
  IconLayoutGrid,
  IconLine,
  IconMinus,
  IconPointer,
  IconRectangle,
  IconStack2,
  IconStairs,
} from "@tabler/icons-react";
import { RibbonButton, RibbonSection } from "@tredespace/ui/widgets";
import type { JSX, ReactNode } from "react";
import type { ToolId } from "../../engine/tools/types.ts";
import { setTool } from "../../state/tool/tool.actions.ts";
import { toolState } from "../../state/tool/tool.state.ts";

type ToolButton = Readonly<{ id: ToolId; label: string; icon: ReactNode; tooltip: string }>;

const TOOLS: readonly ToolButton[] = [
  {
    id: "nav",
    label: "Navigate",
    icon: <IconPointer />,
    tooltip: "Orbit, pan and zoom\nClick planks to toggle them",
  },
  {
    id: "move",
    label: "Move",
    icon: <IconArrowsMove />,
    tooltip: "Drag a scaffold to reposition it\nOnly parts connected to it come along",
  },
  { id: "spir", label: "Standard", icon: <IconStack2 />, tooltip: "Place a standard on any surface" },
  { id: "beam", label: "Beam", icon: <IconMinus />, tooltip: "Click a cup group, then aim" },
  { id: "diag", label: "Diagonal", icon: <IconLine />, tooltip: "Two cups on different standards" },
  { id: "deck", label: "Deck", icon: <IconLayoutGrid />, tooltip: "Deck a closed bay" },
  {
    id: "bracket",
    label: "Bracket",
    icon: <IconArrowBarToRight />,
    tooltip: "Console (konsoll) on a standard\nSK 770 with spigot, or SKD 1250 + 1250 beam",
  },
  { id: "access", label: "Access", icon: <IconStairs />, tooltip: "Stairs, hatch deck and ladder" },
  { id: "rail", label: "Guardrail", icon: <IconFence />, tooltip: "SKRD frame and toe board" },
  {
    id: "plane",
    label: "Plane",
    icon: <IconRectangle />,
    tooltip: "Build planes — surfaces you add where the model has none\nSelect, then move / resize / rotate",
  },
  { id: "del", label: "Delete", icon: <IconEraser />, tooltip: "Click a part to remove it" },
];

export function BuildSection(): JSX.Element {
  const { tool } = toolState.use();

  return (
    <RibbonSection title="Build">
      {TOOLS.map((entry) => (
        <RibbonButton
          key={entry.id}
          icon={entry.icon}
          label={entry.label}
          size="big"
          selected={tool === entry.id}
          tooltip={entry.tooltip}
          onClick={() => setTool(entry.id)}
        />
      ))}
    </RibbonSection>
  );
}
